import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';

import { ProductType } from '@generated/gql/graphql';

import { BroadbandRenewal } from './BroadbandRenewal';
import { CarInsurance } from './CarInsurance';
import { HomeInsurance } from './HomeInsurance';
import { MobileRenewal } from './MobileRenewal';
import './styles.scss';

interface RenewalCaptureProps {
  selectedProducts: ProductType[];
}

const RenewalCapture = ({ selectedProducts }: RenewalCaptureProps) => {
  const showBroadband = !selectedProducts.includes(ProductType.Broadband);
  const showMobile = !selectedProducts.includes(ProductType.Mobile);

  return (
    <Card
      variant="emphasis"
      direction="column"
      spacing="xl"
      className="renewalCapture"
    >
      <Flex direction="column" spacing="lg">
        <Heading as="h3" size="md">
          Stuck in a contract?
        </Heading>
        <BodyText>
          Let us know when your current contracts and policies expire and we'll
          follow up with a reminder closer to the time. UW customers save over
          £400 when they switch all their services.
        </BodyText>
      </Flex>
      {showBroadband && <BroadbandRenewal />}
      {showMobile && <MobileRenewal />}
      <HomeInsurance />
      <CarInsurance />
    </Card>
  );
};

export { RenewalCapture };
